import { reactive } from "vue";

export function useForm<T extends Record<string, unknown>>(initialData: T) {
  const originalData = structuredClone(initialData);
  const data = reactive(initialData);

  function reset() {
    Object.assign(data, originalData);
  }

  return {
    data,
    reset,
  };
}
